import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const ResetPassword = () => {
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailFromUrl = params.get("email");
    const tokenFromUrl = params.get("token");

    if (emailFromUrl) setEmail(decodeURIComponent(emailFromUrl));
    if (tokenFromUrl) setToken(tokenFromUrl);
  }, []);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "⚠️ Missing Fields",
        text: "Please enter both password fields",
        confirmButtonColor: "rgb(204, 102, 0)",
      });
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "❌ Password Mismatch",
        text: "Passwords do not match",
        confirmButtonColor: "rgb(204, 102, 0)",
      });
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        "https://admin.businessunbuzzed.com/api/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            token,
            email,
            password,
            password_confirmation: confirmPassword,
          }),
        }
      );

      const data = await res.json();

      if (data.message) {
        Swal.fire({
          icon: "success",
          title: "✅ Password Reset",
          text: data.message,
          confirmButtonColor: "rgb(204, 102, 0)",
        }).then(() => {
          window.location.href = "/";
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "❌ Reset Failed",
          text: "Please try again",
          confirmButtonColor: "rgb(204, 102, 0)",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "⚠️ Something went wrong!",
        text: "Please try again later",
        confirmButtonColor: "rgb(204, 102, 0)",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-left">
          <h2 className="auth-title">Reset Your Password 🔐</h2>
          <p className="auth-subtitle">Please set your new password</p>

          <form className="auth-form" onSubmit={handleResetPassword}>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={email} readOnly />
            </div>

            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm your new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-custom" disabled={loading}>
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>

          <p className="auth-text">
            Remember your password? <a href="/login">Back to Login</a>
          </p>
        </div>

        <div className="auth-right">
          <img
            src="/img/international-business.png"
            alt="Reset Password"
            className="auth-image"
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
